const API_BASE_URL = String(process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');

export function buildApiUrl(path) {
  const value = String(path || '');
  const normalizedPath = value.startsWith('/') ? value : `/${value}`;
  return API_BASE_URL ? `${API_BASE_URL}${normalizedPath}` : normalizedPath;
}